import { render, staticRenderFns } from "./Func16Novo.vue?vue&type=template&id=3c677d8d&scoped=true"
import script from "./Func16Novo.vue?vue&type=script&lang=js"
export * from "./Func16Novo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c677d8d",
  null
  
)

export default component.exports